var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"DeliveryNotDefined"}},[_c('button',{on:{"click":function($event){return _vm.$router.push(_vm.status.template.route)}}},[_c('span',[_vm._v(" "+_vm._s(_vm.status.template.down)+" ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }